import React, { Component } from 'react';
import { connect } from 'react-redux';
import { submit } from "redux-form";
import { withRouter } from 'react-router';
import { Scrollbars } from 'react-custom-scrollbars';
import { Button } from 'reactstrap';

import Aux from '../../../system/containers/Aux';
import { validateUser } from '../../../system/utils/UserPermissions';
import Form from '../../City/Form';

import { actionCreators } from '../../../store/cities';
import {getCities} from "../../../store/overview";

class DealNewCityWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requiredPermissions: ["CREATE_CITY", "ALL"]
    };
  }

  submit = values => {
    this.props.dispatch(actionCreators.create(values));
  };

  componentWillMount() {
    validateUser(this.props.permissions, this.state.requiredPermissions);
  }

  render() {
    const props = this.props;
    return (
      <Aux>
        <div className={"m-3"}>
        <Form onSubmit={this.submit} mode="create" />
        <Button
          color="success"
          disabled={props.loading}
          onClick={() => { props.dispatch(submit("CityForm")); window.setTimeout(() => { props.dispatch(getCities()) }, 1000) }}
        >
          Save City
        </Button>
        </div>
      </Aux>
    )
  }
}

function mapStateToProps(store) {
  return {
    permissions: store.auth.permissions,
    loading: store.test.loading,
    data: store.test.entry
  }
}

export default connect(mapStateToProps)(DealNewCityWrapper);


// WEBPACK FOOTER //
// ./src/containers/Deals/components/DealNewCityWrapper.jsx